import { useSyncExternalStore } from 'react';

const BECOME_DEBUG_LOG_KEY = 'BECOME_DEBUG_LOG';

type DebugListener = () => void;

const listeners = new Set<DebugListener>();

const notifyDebugListeners = () => {
  listeners.forEach(listener => listener());
};

/** Subscribe to debug-flag changes (for React / useSyncExternalStore). */
export function subscribeDebugEnabled(listener: DebugListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

// Legge il flag da localStorage (solo stringa "true" abilita il logging)
export function isDebugEnabled(): boolean {
  try {
    return localStorage.getItem(BECOME_DEBUG_LOG_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setDebugEnabled(enabled: boolean) {
  try {
    localStorage.setItem(BECOME_DEBUG_LOG_KEY, enabled ? 'true' : 'false');
  } catch {
    // ignore
  }
  notifyDebugListeners();
}

/** React hook: re-renders when developer mode is toggled. */
export function useDebugEnabled(): boolean {
  return useSyncExternalStore(
    subscribeDebugEnabled,
    isDebugEnabled,
    () => false
  );
}

// Inizializza il flag se presente in querystring (?debug=1/0/true/false)
export function initDebugFlagFromQuery() {
  try {
    const params = new URLSearchParams(window.location.search);
    const q = params.get('debug');
    if (q != null) {
      const on = ['1', 'true', 'on', 'yes'].includes(q.toLowerCase());
      setDebugEnabled(on);
    }
  } catch {
    // ignore
  }
}

// Espone utilità globali comode da console
export function exposeAblyDebugGlobals() {
  (window as any).enableDebugLog = () => setDebugEnabled(true);
  (window as any).disableDebugLog = () => setDebugEnabled(false);
  (window as any).isDebugLogEnabled = isDebugEnabled;
}

export const DEBUG_KEYS = {
  BECOME_DEBUG_LOG_KEY: BECOME_DEBUG_LOG_KEY,
} as const;
